import React, { useEffect, useState } from 'react';
import { Layout, Menu, Typography, Card, Button, Space, Drawer } from 'antd';
import { HomeOutlined, ApiOutlined, MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';
import APISection from './APISection';

const { Header, Content, Sider, Footer } = Layout;
const { Title, Text } = Typography;

function App() {
  const [apiConfigs, setApiConfigs] = useState([]);
  const [collapsed, setCollapsed] = useState(window.innerWidth < 768); // 初始根据屏幕宽度判断是否折叠
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [drawerVisible, setDrawerVisible] = useState(false);

  useEffect(() => {
    fetch('./config.json')
      .then((response) => response.json())
      .then((data) => setApiConfigs(data))
      .catch((error) => console.error('加载配置失败:', error));

    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      setCollapsed(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {/* 顶部导航栏 */}
      <Header style={{ display: 'flex', alignItems: 'center', background: '#001529', padding: '0 20px' }}>
        {isMobile ? (
          <Button
            type="text"
            icon={<MenuUnfoldOutlined style={{ color: '#fff', fontSize: '18px' }} />}
            onClick={() => setDrawerVisible(true)}
            style={{ marginRight: 16 }}
          />
        ) : (
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined style={{ color: '#fff' }} /> : <MenuFoldOutlined style={{ color: '#fff' }} />}
            onClick={() => setCollapsed(!collapsed)}
            style={{ fontSize: '18px', marginRight: 16 }}
          />
        )}
        <Title level={3} style={{ color: '#fff', margin: 0, fontSize: isMobile ? '18px' : '24px' }}>
          免费API调试工作台
        </Title>
      </Header>

      <Layout>
        {/* 侧边栏（桌面端） */}
        {!isMobile && (
          <Sider collapsible collapsed={collapsed} onCollapse={setCollapsed} width={200} style={{ background: '#fff' }}>
            <Menu mode="inline" defaultSelectedKeys={['home']} style={{ height: '100%', borderRight: 0 }}>
              <Menu.Item key="home" icon={<HomeOutlined />}>
                {!collapsed && <a href="https://szyd.xyz/">返回主页</a>}
              </Menu.Item>
              {apiConfigs.map((config, index) => (
                <Menu.Item key={`api-${index}`} icon={<ApiOutlined />}>
                  {!collapsed && config.title}
                </Menu.Item>
              ))}
            </Menu>
          </Sider>
        )}

        {/* 移动端的抽屉侧边栏 */}
        <Drawer
          title="菜单"
          placement="left"
          closable
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
        >
          <Menu mode="inline" defaultSelectedKeys={['home']} style={{ height: '100%' }}>
            <Menu.Item key="home" icon={<HomeOutlined />} onClick={() => setDrawerVisible(false)}>
              <a href="https://szyd.xyz/">返回主页</a>
            </Menu.Item>
            {apiConfigs.map((config, index) => (
              <Menu.Item key={`api-${index}`} icon={<ApiOutlined />} onClick={() => setDrawerVisible(false)}>
                {config.title}
              </Menu.Item>
            ))}
          </Menu>
        </Drawer>

        {/* 主体内容 */}
        <Layout style={{ padding: '16px', overflowX: 'hidden' }}>
          <Content
            style={{
              background: '#fff',
              padding: isMobile ? '12px' : '24px',
              margin: 0,
              minHeight: 280,
            }}
          >
            <Title level={4} style={{ textAlign: 'center', marginBottom: 16, fontSize: isMobile ? '16px' : '20px' }}>
              本工作台提供多个免费API接口，可用于测试和调试。
            </Title>

            <Text type="danger" strong style={{ fontSize: isMobile ? '12px' : '14px' }}>
              删除默认参数可能会导致页面问题！！！
            </Text>

            {/* API 卡片列表 */}
            <Space direction="vertical" size="large" style={{ width: '100%', marginTop: 20 }}>
              {apiConfigs.map((config, index) => (
                <Card key={index} title={config.title} style={{ fontSize: isMobile ? '14px' : '16px' }}>
                  <Text>{config.description}</Text>
                  <APISection apiConfig={config} />
                </Card>
              ))}
            </Space>
          </Content>

          {/* 底部 */}
          <Footer style={{ textAlign: 'center', fontSize: isMobile ? '12px' : '14px' }}>
            API 调试平台 ©2025 Created by Szyd
          </Footer>
        </Layout>
      </Layout>
    </Layout>
  );
}

export default App;
